import React from "react";
import { Image } from "spectacle";
import any from "./any.png";

export const S59a = () => <Image src={any} />;
